import { isNotNull, isDefined, isEmpty } from './validate'

export function removeEmptyObj(obj: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, v]) => isNotNull(v) && isDefined(v) && !isEmpty(v)
    )
  )
}
